import { render, staticRenderFns } from "./FoodDiaryDay.vue?vue&type=template&id=dfb252de"
import script from "./FoodDiaryDay.vue?vue&type=script&lang=js"
export * from "./FoodDiaryDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports